module.exports = __webpack_public_path__ + "media/sounds/incorrect_answer_1-3b5aa2838591c849805de08095a892a6.mp3";